<template>
    <div class="investors-presentations">
        <app-docs :docs="presentations" :list="false"></app-docs>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import Presentations from './presentations.json'
import ShareButton from "../shared/ShareButton";
import Docs from "../shared/Docs";
export default {
  components: {
    appShareButton: ShareButton,
    appDocs: Docs
  },
  data() {
      return {
          presentations: Presentations
      }
  }
};</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/investors/Presentations.vue